import React from 'react';

interface GradientButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  children: React.ReactNode;
}

const GradientButton: React.FC<GradientButtonProps> = ({ children, className = '', ...props }) => {
  return (
    <button
      type={props.type || 'button'}
      className={`inline-flex items-center justify-center px-6 py-3 md:px-6 md:py-3 rounded-xl md:rounded-xl bg-gradient-to-r from-blue-600 to-purple-600 text-white text-base md:text-base font-semibold hover:from-blue-700 hover:to-purple-700 cursor-pointer transition-all duration-300 transform hover:-translate-y-1 shadow-lg focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500 disabled:opacity-75 disabled:cursor-not-allowed w-full max-w-xs mx-auto md:w-auto md:max-w-none md:mx-0 ${className}`}
      {...props}
    >
      {children}
    </button>
  );
};

export default GradientButton; 